import { createFileRoute } from "@tanstack/react-router";

import { ROUTE_STATIC } from "~/utils/routeStaticData";

// Unknown subpaths render nothing; the section layout shows its 404 notice
// and redirects to the first permitted tab (RouteTabPage parity).
export const Route = createFileRoute("/_private/meq-live/$")({
  staticData: ROUTE_STATIC.meqLive,
  component: () => null,
});
